/**
 * Created by yniran on 12/18/14.
 */

define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/chatTab/chatWindowConnecting.tmpl"),
        ChatWindowConnectingView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        ChatWindowConnectingView = Marionette.ItemView.extend({
            className: "chat-window-connecting-container",
            template: template
        });
    });

    return ChatWindowConnectingView;
});